// Custom validator functions
export default{
    isValidDate(value) {
        // The Date type input box provides the value to Vuelidate as yyyy-mm-dd, so we know the year is first. The month and Day are already handled by the input box.
        if (!value) return true; // Accepts either Null date or valid date
        if (value.startsWith('0')) // the year was entered as 2 digits, needs all 4
        {
            return false;
        }

        let parts = value.split('-');

        if (parts[0] > new Date().getFullYear() // Date is in future years
            || parts[0] < '1753' // Year is typed incorrectly or outside SQL bounds
        ) {
            return false;
        }

        return true;
    }
}